"use client";

import { Activity } from "lucide-react";
import { getActivityPreviewComponent } from "@/components/activities/activity-renderers";

export function ActivityVisualization({
  activityId,
  data,
  participants,
}: {
  activityId: string;
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
}) {
  const PreviewComponent = getActivityPreviewComponent(activityId);

  if (!PreviewComponent) {
    return (
      <div className="flex items-center justify-center bg-gradient-to-br from-brand/10 to-brand/20 py-12">
        <Activity className="h-16 w-16 text-brand/50" />
      </div>
    );
  }

  return <PreviewComponent data={data} participants={participants} />;
}
